// extracted by mini-css-extract-plugin
export default {"notification":"YkBgP27aUe"};